module.exports = __webpack_public_path__ + "img/app1.d688bcb2.jpg";